var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('Sidenav',{attrs:{"sidebar":_vm.sidebar},on:{"update:sidebar":function($event){_vm.sidebar=$event}}}),(this.$route.name !== 'Embedded Dashboard')?_c('Topbar',{attrs:{"sidebar":_vm.sidebar},on:{"update:sidebar":function($event){_vm.sidebar=$event}}}):_vm._e(),_c('v-main',{staticClass:"background"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }